// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_g1-0";
export var headerCellHover = "_g1-1";
export var readCellContainer = "_g1-2";
export var unreadIndicator = "_g1-3";